import React from "react";
import { History } from "lucide-react";
import { StatusBadge } from "../../StatusBadge";

const CATEGORY_DOT = {
  Schedule: "bg-blue-500", Availability: "bg-purple-500", Attendance: "bg-slate-700",
  Payroll: "bg-emerald-500", Leave: "bg-pink-500", Training: "bg-amber-500",
  Compliance: "bg-red-500", Documents: "bg-indigo-500", Access: "bg-gray-400",
};

/** Monthly Record - Unified Timeline (spec item 12). Purely a renderer over the already
 * built + de-duplicated event list (see lib/monthlyRecordTimeline.js) - never fetches or
 * derives anything itself. */
export const UnifiedTimeline = ({ events }) => (
  <div className="bg-white rounded-xl border border-slate-200 p-5" data-testid="monthly-unified-timeline">
    <div className="flex items-center gap-2 mb-4"><History size={16} className="text-slate-500" /><p className="text-xs font-semibold text-slate-500 uppercase tracking-wide">Unified Timeline</p></div>
    {events.length === 0 ? (
      <p className="text-sm text-slate-500" data-testid="monthly-timeline-empty">No dated events were recorded for this period yet.</p>
    ) : (
      <ol className="relative border-l border-slate-200 ml-2 space-y-4">
        {events.map((e, i) => (
          <li key={`${e.source_id}-${i}`} className="ml-4" data-testid={`monthly-timeline-event-${i}`}>
            <span className={`absolute -left-[5px] w-2.5 h-2.5 rounded-full ${CATEGORY_DOT[e.category] || "bg-slate-400"}`} style={{ marginTop: "4px" }} />
            <div className="flex items-center justify-between gap-3">
              <p className="text-sm font-medium text-slate-800">{e.title}</p>
              {e.status && <StatusBadge status={e.status} />}
            </div>
            <p className="text-xs text-slate-500">{e.category} {"\u00b7"} {e.timestamp ? new Date(e.timestamp).toLocaleString() : ""}</p>
            {e.summary && <p className="text-xs text-slate-400 mt-0.5">{e.summary}</p>}
          </li>
        ))}
      </ol>
    )}
  </div>
);
